import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ClassificationComponent } from './components/classification/classification.component';
import { RelationshipComponent } from './components/relationship/relationship.component';
import { CodesearchComponent } from './components/codesearch/codesearch.component';
// import { ClassificationgridComponent } from './components/classificationgrid/classificationgrid.component';

const app_routes: Routes = [
  { path: 'classification', component: ClassificationComponent },
  { path: 'relationship', component: RelationshipComponent },
  { path: 'search', component: CodesearchComponent },
] ;

@NgModule({
  imports: [ RouterModule.forRoot(app_routes, {useHash: true}) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule { }
